import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const getOrderId = (order) => {
  const orderData = order?.data || order;
  return orderData?.OrderId || orderData?.orderId || orderData?.order_id || null;
};

const useLinkedOrder = (fetchOrders) => {
  const [searchParams] = useSearchParams();
  const [linkedOrder, setLinkedOrder] = useState(null);
  const requestedOrderId = searchParams.get('orderId');

  useEffect(() => {
    let cancelled = false;

    if (!requestedOrderId) {
      setLinkedOrder(null);
      return undefined;
    }

    const loadLinkedOrder = async () => {
      try {
        const result = await fetchOrders('all', 1, 50, requestedOrderId);
        const records = Array.isArray(result?.data) ? result.data : [];
        const matchingOrder = records.find(
          (order) => String(getOrderId(order)) === requestedOrderId
        );

        if (!cancelled) {
          setLinkedOrder(matchingOrder || null);
        }
      } catch (error) {
        if (!cancelled) {
          setLinkedOrder(null);
        }
      }
    };

    loadLinkedOrder();

    return () => {
      cancelled = true;
    };
  }, [fetchOrders, requestedOrderId]);

  return linkedOrder;
};

export default useLinkedOrder;
